import { useContext, useState } from "react";

import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Grid,
  IconButton,
  Tooltip,
} from "@material-ui/core";

import {
  Add,
  DeleteOutlineOutlined,
  EditOutlined,
  ExpandMore,
} from "@material-ui/icons";

import TableDefault from "../../../../components/grid/TableDefault";
import Card from "../../../../components/cards/Card";
import useProdutoController from "../controllers/ProdutoController";
import Chip from "../../../../components/basics/Chip";
import {
  HeaderAccordion,
  HeaderCard,
  IconButtonStyled,
  TableContent,
} from "../styles/Produto";
import { ProdutoContext } from "../contexts/ProdutoContext";
import SearchDialog from "../../../../patterns/modals/SearchDialog";
import SpeedDialErp from "./../../../../components/speeddial/SpeedDialErp";

import { ModalSearchSelect } from "../children/ModalProdutoTransformacao";

export default function AccordionProdutoRelacionado() {
  const {
    relatedProducts,
    setRelatedProducts,
    similarProducts,
    setSimilarProducts,
    transformationProducts,
    setTransformationProducts,

    expanded,
    errors,
  } = useContext(ProdutoContext);

  const { handleChangeOpenAcordion, handleRemoveItemTable } =
    useProdutoController();
  // eslint-disable-next-line
  const [dataTableRelated, setDataTableRelated] = useState([]);
  // eslint-disable-next-line
  const [dataTableSimilar, setDataTableSimilar] = useState([]);
  // eslint-disable-next-line
  const [dataTableTransformation, setDataTableTransformation] = useState([]);
  const [searchProductOpen, setSearchProductOpen] = useState(false);
  const [nameSetterProduct, setNameSetterProduct] = useState(null);
  const [multiSelectable, setMultiSelectable] = useState(false);
  const [modalTransformationOpen, setModalTransformationOpen] = useState(false);
  const [editingTransformationProduct, setEditingTransformationProduct] =
    useState(null);

  const productModalColumns = [
    {
      label: "CÓD.",
      id: "id",
    },
    {
      label: "CÓD. BARRAS",
      id: "codigobarras",
    },
    {
      label: "Produto",
      id: "descricao",
    },
  ];

  const columnsTransformation = [
    {
      id: "acoes",
      label: "Ações",
      align: "center",
      format: (value) => (
        <SpeedDialErp
          actions={[
            {
              icon: <DeleteOutlineOutlined />,
              action: () =>
                handleRemoveItemTable(
                  setTransformationProducts,
                  setDataTableTransformation,
                  transformationProducts,
                  null,
                  value.id
                ),
              name: "Deletar",
            },
            {
              icon: <EditOutlined />,
              action: () => editTransformationProduct(value),
              name: "Editar",
            },
          ]}
        />
      ),
    },
    {
      id: "codigobarras",
      label: "CÓD. BARRAS",
    },
    {
      id: "descricao",
      label: "Produto",
    },
    {
      id: "fator",
      label: "Fator",
    },
  ];

  const relatedProductsColumns = [
    {
      id: "acoes",
      label: "Ações",
      align: "center",
      format: (value) => (
        <>
          <Tooltip title="Deletar">
            <IconButton
              onClick={() =>
                handleRemoveItemTable(
                  setRelatedProducts,
                  setDataTableRelated,
                  relatedProducts,
                  null,
                  value.id
                )
              }
            >
              <DeleteOutlineOutlined />
            </IconButton>
          </Tooltip>
        </>
      ),
    },
    {
      id: "codigobarras",
      label: "CÓD. BARRAS",
    },
    {
      id: "descricao",
      label: "Produto",
    },
  ];

  const similarProductsColumns = [
    {
      id: "acoes",
      label: "Ações",
      align: "center",
      format: (value) => (
        <>
          <Tooltip title="Deletar">
            <IconButton
              onClick={() =>
                handleRemoveItemTable(
                  setSimilarProducts,
                  setDataTableSimilar,
                  similarProducts,
                  null,
                  value.id
                )
              }
            >
              <DeleteOutlineOutlined />
            </IconButton>
          </Tooltip>
        </>
      ),
    },
    {
      id: "codigobarras",
      label: "CÓD. BARRAS",
    },
    {
      id: "descricao",
      label: "Produto",
    },
  ];

  const optionsSetters = {
    setRelatedProducts,
    setSimilarProducts,
    setTransformationProducts,
  };

  const handleSelectProduct = (setOpen, selectedProduct) => {
    if (!nameSetterProduct || !optionsSetters[nameSetterProduct]) return;

    optionsSetters[nameSetterProduct]((current) => [
      ...current,
      ...selectedProduct,
    ]);

    setOpen(null);
  };

  const handleOpenSearchProduct = (setOpen, setNameSetter, nameSetter) => {
    setMultiSelectable(true);
    setOpen(true);
    setNameSetter(nameSetter);
  };

  const addTransformationProduct = (product) => {
    setTransformationProducts((current) => {
      if (editingTransformationProduct) {
        const index = current.findIndex(
          (el) => el.id === editingTransformationProduct.id
        );

        current[index] = product;
        return current;
      } else {
        return [...current, product];
      }
    });

    setModalTransformationOpen(false);
  };

  const editTransformationProduct = (item) => {
    setEditingTransformationProduct({ ...item });

    setModalTransformationOpen(true);
  };

  return (
    <>
      {modalTransformationOpen && (
        <ModalSearchSelect
          open={modalTransformationOpen}
          setOpen={setModalTransformationOpen}
          handleAdd={addTransformationProduct}
          rowEdit={editingTransformationProduct}
        />
      )}
      {searchProductOpen && (
        <SearchDialog
          open={searchProductOpen}
          setOpen={setSearchProductOpen}
          columns={productModalColumns}
          selectable={true}
          multiSelect={multiSelectable}
          handleMainClick={handleSelectProduct}
          route="estoque/produtos/v1"
          title="PRODUTOS"
        />
      )}
      <Grid item xs={12}>
        <Accordion
          expanded={expanded.related || false}
          onChange={() => handleChangeOpenAcordion("related")}
        >
          <AccordionSummary
            expandIcon={<ExpandMore />}
            aria-controls="panel1bh-content"
            id="panel1bh-header"
          >
            <HeaderAccordion>
              <Grid container>
                <Grid item xs={12}>
                  <Chip
                    bgcolor={
                      !expanded.related &&
                      errors.accordions &&
                      errors.accordions.includes("related")
                        ? "red"
                        : "default"
                    }
                    textcolor={
                      !expanded.related &&
                      errors.accordions &&
                      errors.accordions.includes("related")
                        ? "white"
                        : "default"
                    }
                    label={"RELACIONADOS, SIMILARES E TRANSFORMAÇÃO"}
                  />
                </Grid>
              </Grid>
            </HeaderAccordion>
          </AccordionSummary>

          <AccordionDetails>
            <Grid container spacing={2}>
              <Grid item md={6} xs={12}>
                <Card line="left" lineColor="primary">
                  <HeaderCard>
                    <Grid container spacing={2} alignItems="center">
                      <Grid item xs>
                        <Chip label="RELACIONADOS" bgcolor="secondary" />
                      </Grid>
                      <Grid item flex={1}>
                        <Tooltip title="Adicionar produto relacionado">
                          <IconButtonStyled
                            onClick={() => {
                              handleOpenSearchProduct(
                                setSearchProductOpen,
                                setNameSetterProduct,
                                "setRelatedProducts"
                              );
                            }}
                            style={{ padding: 8 }}
                          >
                            <Add />
                          </IconButtonStyled>
                        </Tooltip>
                      </Grid>
                    </Grid>
                  </HeaderCard>

                  <Grid container spacing={2}>
                    <Grid item xs={12}>
                      <TableContent>
                        <Grid container spacing={2}>
                          <Grid item xs={12}>
                            <TableDefault
                              columns={relatedProductsColumns}
                              values={relatedProducts}
                              tableTitle=""
                              maxHeight="35vh"
                              stickyHeader
                            />
                          </Grid>
                        </Grid>
                      </TableContent>
                    </Grid>
                  </Grid>
                </Card>
              </Grid>

              <Grid item md={6} xs={12}>
                <Card line="left" lineColor="primary">
                  <HeaderCard>
                    <Grid container spacing={2} alignItems="center">
                      <Grid item xs>
                        <Chip label="SIMILARES" bgcolor="secondary" />
                      </Grid>
                      <Grid item flex={1}>
                        <Tooltip title="Adicionar produto similar">
                          <IconButtonStyled
                            onClick={() => {
                              handleOpenSearchProduct(
                                setSearchProductOpen,
                                setNameSetterProduct,
                                "setSimilarProducts"
                              );
                            }}
                            style={{ padding: 8 }}
                          >
                            <Add />
                          </IconButtonStyled>
                        </Tooltip>
                      </Grid>
                    </Grid>
                  </HeaderCard>

                  <Grid container spacing={2} alignItems="center">
                    <Grid item xs={12}>
                      <TableContent>
                        <Grid container spacing={2}>
                          <Grid item xs={12}>
                            <TableDefault
                              columns={similarProductsColumns}
                              values={similarProducts}
                              tableTitle=""
                              maxHeight="35vh"
                              stickyHeader
                            />
                          </Grid>
                        </Grid>
                      </TableContent>
                    </Grid>
                  </Grid>
                </Card>
              </Grid>

              <Grid item xs={12}>
                <Card line="left" lineColor="primary">
                  <HeaderCard>
                    <Grid container spacing={2} alignItems="center">
                      <Grid item xs>
                        <Chip label="TRANSFORMAÇÃO" bgcolor="secondary" />
                      </Grid>
                      <Grid item flex={1}>
                        <Tooltip title="Adicionar transformação">
                          <IconButtonStyled
                            style={{ padding: 8 }}
                            onClick={() => {
                              setEditingTransformationProduct(null);
                              setModalTransformationOpen(true);
                            }}
                          >
                            <Add />
                          </IconButtonStyled>
                        </Tooltip>
                      </Grid>
                    </Grid>
                  </HeaderCard>

                  <Grid container spacing={2}>
                    <Grid item xs={12}>
                      <TableContent>
                        <Grid container spacing={2}>
                          <Grid item xs={12}>
                            <TableDefault
                              columns={columnsTransformation}
                              values={transformationProducts}
                              tableTitle=""
                              maxHeight="35vh"
                              stickyHeader
                            />
                          </Grid>
                        </Grid>
                      </TableContent>
                    </Grid>
                  </Grid>
                </Card>
              </Grid>
            </Grid>
          </AccordionDetails>
        </Accordion>
      </Grid>
    </>
  );
}
